import { render, staticRenderFns } from "./Extend.vue?vue&type=template&id=a90b6f4e&"
import script from "./Extend.vue?vue&type=script&lang=js&"
export * from "./Extend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports